<template>
    <div class="homeinterativa">
        <PageTitle icon="far fa-id-card iconInterativoTitulo" main="Gestão dos Colaboradores"
            sub="Estatísticas Gerais dos Colaboradores" />
        <div class="stats">
            <Stat title="Administradores" :value="stat.maquinas"
                icon="fas fa-user-tie" color="#2e2d2c" />
            <Stat title="Encarregados" :value="stat.baterias"
                icon="fas fa-user-shield" color="#ffd618" />
            <Stat title="Operadores" :value="stat.usuarios"
                icon="fas fa-users" color="#008fac" />
        </div>
    </div>
</template>

<script>
import PageTitle from '../PageTitle'
import Stat from './Stat'
import axios from 'axios'
import { baseApiUrl } from '@/global'

export default {
    name: 'ColaboradorInterativa',
    components: { PageTitle, Stat },
    data: function() {
        return {
            stat: {}
        }
    },
    methods: {
        getStats() {
            axios.get(`${baseApiUrl}/stats`).then(res => this.stat = res.data)
        }
    },
    mounted() {
        this.getStats()
    }
}
</script>

<style>
    .stats {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        padding: 20px;
    }
    .homeinterativa{
        position: relative;
        width: 100%;
        height: 100%;
    }
</style>